import { QueryClient } from '@tanstack/react-query'
import { fetchPage } from '@vangst/services/oogst/page'
import { RobotsEnum } from '@vangst/services/oogst/types'
import Routes from '@vangst/services/routes'
import { InferGetStaticPropsType } from 'next'
import Breadcrumbs from '../../components/navigation/Breadcrumbs'
import PageHeader from '../../components/views/PageHeader'
import Meta from '../../domains/application/Meta'
import {
  GoForgotPassword,
  GoSignUp,
} from '../../domains/viewer/navigation/GoDoThings'
import SignInForm from '../../domains/viewer/SignInForm'
import useAuthedRedirect from '../../domains/viewer/useAuthedRedirect'

export async function getStaticProps() {
  const queryClient = new QueryClient()
  const rawUrl = __filename.split('pages')[1]?.replace('.js', '')
  const { getPage } = await fetchPage(queryClient, { rawUrl })
  const page = {
    ...getPage,
    title: getPage?.title ?? 'Sign In',
    subtitle: getPage?.subtitle ?? 'Welcome back!',
  }
  const crumbs = [
    { href: Routes.INDEX, text: 'Home' },
    { href: null, text: 'Sign In' },
  ]

  return {
    props: { crumbs, page },
    revalidate: 30,
  }
}

// -------------------------------------

type PropsType = InferGetStaticPropsType<typeof getStaticProps>

export default function SignInPage(props: PropsType) {
  useAuthedRedirect()
  const { crumbs, page } = props

  return (
    <>
      <Meta
        key="meta"
        canonicalUrl={page.metaInfo?.canonicalUrl}
        crumbs={crumbs}
        description={page.metaInfo?.description}
        image={page.pagePhotos?.[0]?.url}
        publishDate={page.postedAt}
        robots={page.metaInfo?.robots ?? RobotsEnum.IndexFollow}
        title="Sign In for Cannabis Industry Jobs, Education, Reports and Information | Vangst"
      />
      <Breadcrumbs crumbs={crumbs} />
      <article className="mood-white">
        <PageHeader
          accent="text-white"
          className="bg-orange text-white"
          icon="people"
          title={page.title}
          subtitle={page.subtitle}
          description={page.description}
          imgAlt={page.pagePhotos?.[0]?.alt}
          imgSrc={page.pagePhotos?.[0]?.url}
        />
        <div className="contain-c">
          <section className="contain-xy flex max-w-prose flex-col gap-8 md:ml-24">
            <SignInForm as="page" />
            <GoForgotPassword />
            <GoSignUp />
          </section>
        </div>
      </article>
    </>
  )
}
